import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { rupee } from "../lib/api";
import { OrderTimeline } from "../components/OrderTimeline";
import { Search } from "lucide-react";

export default function TrackOrder() {
  const { orderNumber: paramNum } = useParams();
  const [num, setNum] = useState(paramNum || "");
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");

  const fetchOrder = async (n) => {
    if (!n) return;
    setError("");
    try { const { data } = await api.get(`/orders/track/${n}`); setOrder(data); }
    catch (e) { setError("Order not found. Check your order number."); setOrder(null); }
  };

  useEffect(() => { if (paramNum) fetchOrder(paramNum); }, [paramNum]);

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10" data-testid="track-order-page">
      <h1 className="font-serif text-4xl text-navy mb-6">Track Your Order</h1>
      <div className="flex gap-2 mb-6">
        <div className="flex items-center bg-white border border-black/10 rounded-full px-4 py-2.5 flex-1 focus-within:ring-2 focus-within:ring-gold">
          <Search size={18} className="text-muted-foreground" />
          <input value={num} onChange={(e) => setNum(e.target.value)} placeholder="Enter order number (e.g. BBS...)" data-testid="track-input" className="bg-transparent outline-none text-sm ml-2.5 flex-1" />
        </div>
        <button onClick={() => fetchOrder(num)} data-testid="track-search-btn" className="bg-navy text-cream font-semibold px-6 rounded-full hover:bg-navy-soft transition-colors">Track</button>
      </div>
      {error && <div className="text-destructive text-sm" data-testid="track-error">{error}</div>}
      {order && (
        <div className="bg-white rounded-xl border border-black/5 p-6" data-testid="track-result">
          <div className="flex justify-between items-center mb-6">
            <div><div className="text-xs text-muted-foreground uppercase tracking-wider">Order</div><div className="font-semibold text-navy">{order.order_number}</div></div>
            <span className="text-xs bg-gold/15 text-navy font-medium px-3 py-1.5 rounded-full capitalize">{order.status.replace(/_/g, " ")}</span>
          </div>
          <OrderTimeline status={order.status} />
          <div className="gold-rule my-5" />
          <div className="space-y-1.5">
            {order.items.map((it, i) => <div key={i} className="flex justify-between text-sm"><span className="text-navy">{it.name} × {it.quantity}</span><span className="text-muted-foreground">{rupee(it.total)}</span></div>)}
          </div>
          <div className="flex justify-between font-semibold text-navy mt-4 pt-4 border-t border-black/10"><span>Total</span><span>{rupee(order.grand_total)}</span></div>
        </div>
      )}
    </div>
  );
}
